import { Components } from '@mui/material/styles';
import { alpha } from '@mui/system';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

const MuiIconButton: Components['MuiIconButton'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      padding: '6px',
      '&.MuiIconButton-colorInfo': {
        backgroundColor: palette.info.main,
        color: palette.common.white,
      },
      '&.MuiIconButton-colorWarning': {
        backgroundColor: palette.warning.main,
        color: palette.grey[600],
      },
      '&.MuiIconButton-colorSuccess': {
        backgroundColor: palette.success.main,
        color: palette.common.white,
      },
      '&.MuiIconButton-colorError': {
        backgroundColor: palette.error.main,
        color: palette.common.white,
      },
      '&.Mui-disabled': {
        // TODO: refactor without type assertion, or add comment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: alpha(palette.grey[600] as string, 0.3),
        // TODO: refactor without type assertion, or add comment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backgroundColor: alpha(palette.grey[600] as string, 0.3),
      },
      '& .MuiCircularProgress-root': {
        color: 'inherit',
        width: `${pxToEm(38)} !important`,
        height: `${pxToEm(38)} !important`,
      },
      '&.isLoading': {
        pointerEvents: 'none',
        opacity: '0.5',
      },
      '&.isDense': {
        '.MuiCircularProgress-root': {
          width: `${pxToEm(22)} !important`,
          height: `${pxToEm(22)} !important`,
        },
      },
      '&.withLabel': {
        borderRadius: `${pxToEm(38)} !important`,
      },
    },
    colorSecondary: {
      color: palette.grey[600],
      backgroundColor: palette.secondary?.main,

      '&:hover': {
        backgroundColor: palette.primary?.main,
        color: palette.common.white,
      },

      '&:focus, &:active': {
        backgroundColor: palette.common.white,
        color: palette.grey[600],
      },
    },
    colorPrimary: {
      backgroundColor: palette.grey[600],
      color: palette.common.white,
      '&:hover': {
        backgroundColor: palette.primary.light,
      },
      '&:focus': {
        backgroundColor: palette.primary.dark,
      },
      '&.Mui-disabled': {
        color: palette.common.white,
        // TODO: refactor without type assertion, or add comment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backgroundColor: alpha(palette.grey[600] as string, 0.3),
      },
    },
    sizeSmall: {
      fontSize: pxToEm(10),
    },
    sizeMedium: {
      fontSize: pxToEm(14),
    },
    sizeLarge: {
      fontSize: pxToEm(16),
    },
  },
};

export { MuiIconButton };
